import { render, staticRenderFns } from "./autoCancelOrderConfigModal.vue?vue&type=template&id=4e1a6fda"
import script from "./autoCancelOrderConfigModal.vue?vue&type=script&lang=js"
export * from "./autoCancelOrderConfigModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports